import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    getAccountingFactoryList, getFactoryFailureCodeList,
    getFactorySystemEffectList, updateClaimDataByMode,
} from '../repositories';
import { getDesignModule, getMfgModule } from '../../app/common/repositories';
import { CancelOnlyModal } from '../../shared/components/modals/cancel-only-modal';
import InputWithFaIcon from '../../shared/components/labeled-input-with-fa-icon';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../shared/services/customize-error-alert-bar';
import { getFieldValue } from '../../shared/services/common-functions';
import { getPartNumber } from '../../admin/repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import BusyCounterLoadingIndicator from "../../shared/components/busyCounter/busy-counter-loading-indicator";

class FunctionCodeDetails extends Component {

    state = {
        confirmTitle: '',
        confirmIsOpen: false,
        DesignModuleList: [],
        MfgModuleList: [],
        editableFields: {},
        functionCodeList: [],
        factoryFailureCodeList: [],
        factorySystemEffectList: [],
        accountingFactoryList: [],
        showLoader:this.props.busyCounter

    }

    defaultProp = {
        manufacturingModule: this.props.claimPartDetails.factory !== undefined ? getFieldValue( this.props.claimPartDetails.factory.manufacturingModule ) : '',

        designModule: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.designTeamCode ) : '',

        functionCode: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.functionCodeId ) : '',

        factorySystemEffect: this.props.claimPartDetails.factory !== undefined ? getFieldValue( this.props.claimPartDetails.factory.factorySystemEffect ) : '',

        factoryFailureModeCode: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.factoryFailureMode ) : '',

        factoryDowntimeFailureFlag:
            this.props.claimPartDetails.factory !== undefined ?
                getFieldValue( this.props.claimPartDetails.factory.factoryDowntimeFailure ) : '',

        responsibleGroup: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.responsibleGroup ) : '',

        accountingFactoryCode: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.accountingFactory ) : '',

        analysisFactoryCode:
            this.props.claimPartDetails.factory !== undefined ?
                getFieldValue( this.props.claimPartDetails.factory.analysisFactory ) : '',

        nccaCaseNumber: this.props.claimPartDetails !== undefined ? getFieldValue( this.props.claimPartDetails.nccaCaseNumber ) : '',

        dtacCaseNumber: this.props.claimPartDetails !== undefined ? getFieldValue( this.props.claimPartDetails.dtacCaseNumber ) : '',

        dtacSolutionNumber: this.props.claimPartDetails !== undefined ? getFieldValue( this.props.claimPartDetails.dtacSolutionNumber ) : '',

        partSupplierId: this.props.claimPartDetails.factory !== undefined ?
            getFieldValue( this.props.claimPartDetails.factory.partSupplierId ) : '',
    }

    dtacCaseNumber = '';

    repairReplace = '';

    dtacSolutionNumber = '';

    isCmpFieldEdited = false;

    componentDidUpdate = () => {

        this.assignValue( this.props.claimPartDetails );
    
    };


    componentWillMount = () => {

        this.assignValue( this.props.claimPartDetails );

        getDesignModule( this.props.claimPartDetails.factory.analysisFactory ).then( response => {

            this.setState( {

                DesignModuleList: response,

            } );

        } ).catch( () => {


        } );

        getMfgModule( this.props.claimPartDetails.factory.analysisFactory ).then( response => {

            this.setState( {

                MfgModuleList: response,

            } );

        } ).catch( () => {


        } );

        getFactoryFailureCodeList().then( response => {

            this.setState( {

                factoryFailureCodeList: response,

            } );

        } ).catch( () => {


        } );

        getFactorySystemEffectList().then( response => {

            this.setState( {

                factorySystemEffectList: response,

            } );

        } ).catch( () => {


        } );

        getAccountingFactoryList( this.props.factoryCode ).then( response => {

            this.setState( {

                accountingFactoryList: response,

            } );

        } ).catch( () => {


        } );


        this.setState( {
            editableFields: this.defaultProp,
        } );

    }

    assignValue = claimPartDetails => {

        if ( claimPartDetails !== undefined ) {

            this.repairReplace = getFieldValue( claimPartDetails.repairReplace );
            this.dtacCaseNumber = getFieldValue( claimPartDetails.dtacCaseNumber );
            this.dtacSolutionNumber = getFieldValue( claimPartDetails.dtacSolutionNumber );

        }

    }

    componentWillReceiveProps = nextProps => {

        const obj = {
            manufacturingModule: getFieldValue( nextProps.claimPartDetails.factory
                .manufacturingModule ),

            designModule: getFieldValue( nextProps.claimPartDetails.factory
                .designTeamCode ),

            functionCode: getFieldValue( nextProps.claimPartDetails.factory
                .functionCodeId ),

            factorySystemEffect: getFieldValue( nextProps.claimPartDetails.factory
                .factorySystemEffect ),

            factoryFailureModeCode: getFieldValue( nextProps.claimPartDetails.factory
                .factoryFailureMode ),

            factoryDowntimeFailureFlag: getFieldValue( nextProps.claimPartDetails.factory
                .factoryDowntimeFailure ),

            responsibleGroup: getFieldValue( nextProps.claimPartDetails.factory
                .responsibleGroup ),

            accountingFactoryCode: getFieldValue( nextProps.claimPartDetails.factory
                .accountingFactory ),

            analysisFactoryCode: getFieldValue( nextProps.claimPartDetails.factory
                .analysisFactory ),

            nccaCaseNumber: getFieldValue( nextProps.claimPartDetails.nccaCaseNumber ),

            partSupplierId: getFieldValue( nextProps.claimPartDetails.factory.partSupplierId ),
        };
        this.defaultProp = obj;
        this.setState( {
            editableFields: obj,
        } );

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Function Codes' );

    }


    onSaveBtnClicked = () => {

        const updatedData = {};
        let checkFunctionCode = 0;
        let count = 0;

        if ( this.isCmpFieldEdited ) {

            const updatedFunctionCodeData = {
                manufacturingModule: this.state.editableFields.manufacturingModule,

                designModule: this.state.editableFields.designModule,

                functionCode: this.state.editableFields.functionCode,

            };

            Object.keys( this.defaultProp ).forEach( element => {

                Object.keys( this.state.editableFields ).forEach( ele => {

                    if ( element === ele ) {

                        if ( this.defaultProp[element] !== this.state.editableFields[ele] ) {

                            if ( updatedFunctionCodeData[element] !== undefined ) {

                                checkFunctionCode += 1;

                            } else {

                                updatedData[ele] = this.state.editableFields[ele];

                            }

                        }

                    }

                } );

            } );


            if ( checkFunctionCode > 0 ) {

                count += 1;

            }

            if ( Object.entries( updatedData ).length > 0 ) {

                count += 1;

            }


            if ( checkFunctionCode > 0 ) {

                updateClaimDataByMode( 'functionCode', this.props.claimNumber, updatedFunctionCodeData ).then( () => {

                    count -= 1;

                    if ( count === 0 ) {

                        this.props.updateClaim( this.props.claimNumber );

                    }

                } ).catch( error => {

                    customizeErrorAlert( error.message );

                } );

            }
            if ( Object.entries( updatedData ).length > 0 ) {
                
                updateClaimDataByMode( 'functionCode-otherFields', this.props.claimNumber, updatedData ).then( () => {

                    count -= 1;
                    if ( count === 0 ) {

                        this.props.updateClaim( this.props.claimNumber );

                    }

                } ).catch( error => {

                    customizeErrorAlert( error.message );

                } );

            }
            this.props.enableEditCmp( 'Function Codes' );

        } else this.onCancelBtnClicked();

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Function Codes' ) ) {

            this.setState( {
                editableFields: this.defaultProp,

            } );

        }

    }

    handleOnChange = ( name, val ) => {
        
        const updatedVal = { ...this.state.editableFields };
        updatedVal[name] = val;

        this.isCmpFieldEdited = true;

        this.setState( {
            editableFields: updatedVal,
        } );

    }

    handleUpdate = val => {
        console.log("handleUpdate::");
        const updatedVal = { ...this.state.editableFields };
        updatedVal[val.target.name] = val.target.value;

        this.isCmpFieldEdited = true;

        this.setState( {
            editableFields: updatedVal,
        } );

    }

    handleConfirmClose = () => {

        this.setState( {
            confirmIsOpen: false,
        } );

    }

    handleClinkFunctionCode = () => {

        const obj = {
            productSeries: 0,
            partNumber: this.props.claimPartDetails.partNumber.corrected,
        };
        // this.props.increaseCounter();
        this.setState({showLoader:true})
        getPartNumber( this.props.claimPartDetails.factory.analysisFactory, obj ).then(
            responce => {

                this.setState( {
                    confirmIsOpen: true,
                    confirmTitle: 'Select Function Code',
                    functionCodeList: responce,
                } );
                // this.props.decreaseCounter();
                this.setState({showLoader:false})

            },
        ).catch( () => {
            // this.props.decreaseCounter();
            this.setState({showLoader:false})

        } );

    }

    updateFunctionCode = e => {

        const obj = { ...this.state.editableFields };
        obj.manufacturingModule = e.manufacturingModule;
        obj.designModule = e.designTeamCode;
        obj.functionCode = e.functionCodeName;
        this.setState( {
            editableFields: obj,
        } );
        this.isCmpFieldEdited = true;
        this.handleConfirmClose();

    }

    render () {

        const { corrected } = this.props.claimPartDetails.partNumber;

        return (

            <div className="basic-claim">
                <BusyCounterLoadingIndicator busyCounter={this.state.showLoader} />
                <section className="generic-function-information">

                    <header>
                        {this.props.isComponentEdit && (
                            <h4 className="page-header">
                                <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                                <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                                <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                            </h4>
                        )}
                    </header>

                    <div className="function-code-info">
                        <div className="rows">
                            <div className="four-cols drop-down">
                                {!this.props.isEdit && (
                                    <div>
                                        <label>Mfg Module</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.manufacturingModule}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Mfg Module"
                                        optionDisplayAttributes={['name']}
                                        optionKey="name"
                                        options={this.state.MfgModuleList}
                                        onChange={this.handleOnChange.bind( this.props, 'manufacturingModule' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields
                                            .manufacturingModule}
                                    />
                                )}
                            </div>
                            <div className="four-cols drop-down">
                                {!this.props.isEdit && (
                                    <div>
                                        <label>Design Module</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.designModule}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Design Module"
                                        optionDisplayAttributes={['name']}
                                        optionKey="name"
                                        options={this.state.DesignModuleList}
                                        onChange={this.handleOnChange.bind( this.props, 'designModule' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields.designModule}
                                    />
                                )}
                            </div>

                            <div className="four-cols">
                                <InputWithFaIcon
                                    className="basic-claim-info"
                                    name="functionCode"
                                    isEditable={this.props.isEdit}
                                    label="Function Code"
                                    onChange={this.handleUpdate}
                                    value={this.state.editableFields.functionCode}
                                    iconClassName="fa fa-binoculars"
                                    type="text"
                                    onIconClick={this.handleClinkFunctionCode}
                                />
                            </div>


                            <div className="four-cols drop-down">
                                {!this.props.isEdit && (
                                    <div>
                                        <label>Factory System Effect</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.factorySystemEffect}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Factory System Effect"
                                        optionDisplayAttributes={['factorySystemEffectCode']}
                                        optionKey="name"
                                        options={this.state.factorySystemEffectList}
                                        onChange={this.handleOnChange.bind( this.props, 'factorySystemEffect' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields
                                            .factorySystemEffect}
                                    />
                                )}
                            </div>

                        </div>

                        <div className="rows">
                            <div className="four-cols drop-down">

                                {!this.props.isEdit && (
                                    <div>
                                        <label>Factory Failure Mode Code</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.factoryFailureModeCode}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Factory Failure Mode Code"
                                        optionDisplayAttributes={['factoryFailureCode']}
                                        optionKey="name"
                                        options={this.state.factoryFailureCodeList}
                                        onChange={this.handleOnChange.bind( this.props, 'factoryFailureModeCode' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields
                                            .factoryFailureModeCode}
                                    />
                                )}

                            </div>
                            <div className="four-cols drop-down">

                                <LabeledInput
                                    className="basic-claim-info"
                                    name="factoryDowntimeFailure"
                                    isEditable={this.props.isEdit}
                                    label="Factory Downtime Failure Flag"
                                    onChange={this.handleUpdate}
                                    value={this.state.editableFields
                                        .factoryDowntimeFailureFlag.toString()}
                                />
                            </div>
                            <div className="four-cols">
                                <LabeledInput
                                    className="basic-claim-info"
                                    name="responsibleGroup"
                                    isEditable={this.props.isEdit}
                                    label="Responsible Group"
                                    onChange={this.handleUpdate}
                                    value={this.state.editableFields.responsibleGroup}
                                />
                            </div>

                            <div className="four-cols drop-down">
                                {!this.props.isEdit && (
                                    <div>
                                        <label>Accounting Factory Code</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.accountingFactoryCode}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Accounting Factory Code"
                                        optionDisplayAttributes={['accountingFactory']}
                                        optionKey="name"
                                        options={this.state.accountingFactoryList}
                                        onChange={this.handleOnChange.bind( this.props, 'accountingFactoryCode' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields
                                            .accountingFactoryCode}
                                    />
                                )}

                            </div>

                        </div>

                        <div className="rows">
                            <div className="four-cols drop-down">
                                {!this.props.isEdit && (
                                    <div>
                                        <label>Analysis Factory Code</label>
                                        <span className="drpdwn-labels">{this.state.editableFields.analysisFactoryCode}</span>
                                    </div>
                                )}
                                {this.props.isEdit && (
                                    <OptionsDropDown
                                        className={this.props.isEdit ? 'non-editable' : ''}
                                        isPlaceholderTranslated={true}
                                        label="Analysis Factory Code"
                                        optionDisplayAttributes={['factoryDescription']}
                                        optionKey="factoryCode"
                                        options={this.props.factories.factories}
                                        onChange={this.handleOnChange.bind( this, 'analysisFactoryCode' )}
                                        placeholder=""
                                        selectedValue={this.state.editableFields
                                            .analysisFactoryCode}
                                    />
                                )}

                            </div>
                            <div className="four-cols">

                                <LabeledInput
                                    className="basic-claim-info"
                                    name="nccaCaseNumber"
                                    isEditable={this.props.isEdit}
                                    label="NCCA CAR Number"
                                    onChange={this.handleUpdate}
                                    value={this.state.editableFields.nccaCaseNumber}
                                />
                            </div>
                            <div className="four-cols">
                                <LabeledInput
                                    className="basic-claim-info"
                                    name="partSupplierId"
                                    isEditable={this.props.isEdit}
                                    label="Supplier"
                                    onChange={this.handleUpdate}
                                    value={this.state.editableFields.partSupplierId}
                                />
                            </div>

                            <div className="four-cols">
                                <LabeledInput
                                    className="basic-claim-info"
                                    name="dtacCaseNumber"
                                    isEditable={false}
                                    label="DTAC Case Number"
                                    value={this.dtacCaseNumber}
                                />
                            </div>

                        </div>

                        <div className="rows">
                            <div className="four-cols">
                                <LabeledInput
                                    className="basic-claim-info"
                                    name="dtacSolutionNumber"
                                    isEditable={false}
                                    label="DTAC Sol Number"
                                    value={this.dtacSolutionNumber}
                                />

                            </div>
                            <div className="four-cols">

                                <LabeledInput
                                    className="basic-claim-info"
                                    name="repairReplace"
                                    isEditable={false}
                                    label="Repair/Replace Flag"
                                    value={this.repairReplace}
                                />
                            </div>
                            <div className="four-cols">
                                <LabeledInput
                                    className="basic-claim-info"
                                    name="partGroup"
                                    isEditable={false}
                                    label="Part group"
                                    value={this.props.claimPartDetails.partNumber.partGroup}
                                />
                            </div>

                        </div>
                    </div>

                    <CancelOnlyModal
                        body={(
                            <div>
                                <span className="part-number">
                                    Function Codes for Part Number: {corrected}
                                </span>
                                <table className="function-code-table">
                                    <tr>
                                        <th>Function Code</th>
                                        <th>Series</th>
                                        <th>Manufacturing Module</th>
                                        <th>Design Team</th>
                                    </tr>
                                    {this.state.functionCodeList.map( item => (
                                        <tr>
                                            <td>
                                                <button
                                                    className="btn-link"
                                                    type="button"
                                                    onClick={this.updateFunctionCode
                                                        .bind( this, item )}
                                                >
                                                    {item.functionCodeName}
                                                </button>
                                            </td>
                                            <td>{item.productSeriesName}</td>
                                            <td>{item.manufacturingModule}</td>
                                            <td>{item.designTeamCode}</td>
                                        </tr>
                                    ) )}

                                </table>
                            </div>
                        )}
                        className="function-code-popup"
                        header={this.state.confirmTitle}
                        isOpen={this.state.confirmIsOpen}
                        onCancel={this.handleConfirmClose}
                        onHide={this.handleConfirmClose}
                    />

                </section>
            </div>

        );

    }

}

FunctionCodeDetails.displayName = 'FunctionCodeDetails';
FunctionCodeDetails.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    claimPartDetails: PropTypes.object.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
    factoryCode: PropTypes.string.isRequired,
    claimNumber: PropTypes.string.isRequired,
    updateClaim: PropTypes.func.isRequired,
    factories: PropTypes.object.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( FunctionCodeDetails );
